import React, {useEffect} from 'react';

import './loadingcircle.scss'

const LoadingCircle = ({color = 'white'}:{color?: string}) => {
    return (
        <>
        
        <style 
            dangerouslySetInnerHTML={{__html: `
                .lds-circle div:after {
                    background-color:${color}
                }
            `}} 
        />
        <div className="lds-circle"  data-testid="loading-circle">
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
            <div data-custom-color={color}></div>
        </div>
        
        </>)
}

export default LoadingCircle


